import { Controller } from "@hotwired/stimulus"

// Controller to handle price input with euro formatting
// Stores value in cents but displays in euros
export default class extends Controller {
  static targets = ["input", "display"]

  connect() {
    this.createDisplayInput()
    this.updateDisplay()
  }

  createDisplayInput() {
    // Hide the original input
    this.inputTarget.type = "hidden"

    // Create a display input for the formatted value
    const displayInput = document.createElement("input")
    displayInput.type = "text"
    displayInput.className = this.inputTarget.className
    displayInput.placeholder = "Ex: 19,90 €"
    displayInput.dataset.priceInputTarget = "display"

    // Insert after the hidden input
    this.inputTarget.parentNode.insertBefore(displayInput, this.inputTarget.nextSibling)

    // Listen for changes on display input
    displayInput.addEventListener("input", this.handleInput.bind(this))
    displayInput.addEventListener("blur", this.handleBlur.bind(this))
  }

  updateDisplay() {
    const cents = parseInt(this.inputTarget.value) || 0
    const euros = (cents / 100).toFixed(2).replace(".", ",")
    this.displayTarget.value = cents > 0 ? `${euros} €` : ""
  }

  handleInput(event) {
    // Allow only numbers and comma
    let value = event.target.value.replace(/[^\d,]/g, "")
    event.target.value = value
  }

  handleBlur(event) {
    let value = event.target.value.replace(/[^\d,]/g, "")

    if (value === "") {
      this.inputTarget.value = ""
      return
    }

    // Parse the euro value and convert to cents
    let euros = parseFloat(value.replace(",", ".")) || 0
    let cents = Math.round(euros * 100)

    // Update hidden input with cents
    this.inputTarget.value = cents

    // Format display
    const formatted = (cents / 100).toFixed(2).replace(".", ",")
    event.target.value = `${formatted} €`
  }
}
